.modalBody {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 15px;
}

.textFieldArea {
	display: flex;
	flex-direction: column;
	align-items: start;
	gap: 10px;
}

div.textField {
	width: 379px;
}

.checkboxFormLabel {
	gap: 0.3125rem;
	margin: 0.9375rem 0;
}
